export { default } from "./QuestionnaireCard"
